var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCheckWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 18,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.623 11.715L2.84 6.862 0 9.725l7.623 7.717L22 2.864 19.16 0z",
  fill: "#fff",
  fillRule: "evenodd"
})));
export default SvgCheckWhite;